var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYmo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ymo",
    clipPath: "url(#clip0_2_6051)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.4742 0C10.7425 0 6.94849 3.83659 6.94849 8.52575C6.94849 13.2575 10.7851 17.0515 15.4742 17.0515C20.1634 17.0515 24 13.2149 24 8.52575C24 3.83659 20.1634 0 15.4742 0ZM15.4742 11.6377C13.7265 11.6377 12.2771 10.1883 12.2771 8.4405C12.2771 6.69272 13.7265 5.24334 15.4742 5.24334C17.222 5.24334 18.6714 6.69272 18.6714 8.4405C18.6288 10.2735 17.222 11.6377 15.4742 11.6377ZM6.90586 2.42984V14.8348H3.87922L0 2.42984H6.90586Z",
    fill: "#8B3FFD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_6051"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 17.641,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYmo);
export default __webpack_public_path__ + "static/media/ymo.2da0a1e50d45bdea87e9a1d0456b5740.svg";
export { ForwardRef as ReactComponent };